import { render, staticRenderFns } from "./TestSpeech.vue?vue&type=template&id=d4b5109c&scoped=true"
import script from "./TestSpeech.vue?vue&type=script&lang=ts"
export * from "./TestSpeech.vue?vue&type=script&lang=ts"
import style0 from "./TestSpeech.vue?vue&type=style&index=0&id=d4b5109c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b5109c",
  null
  
)

export default component.exports